export const questionnaire_A2 = {
    name: '問卷 A-2',
    subtitle: '線上閱讀是指利用電腦、平板或手機，閱讀網頁或學習平台上的資料。這些資料除了文字，也可能有圖片、圖表、影片或動畫。閱讀時，<br/>你可能會點擊標籤或超連結，選擇閱讀的頁面和順序；也可能需要把不同網頁或文章的資訊聯繫起來，並判斷資料是否可靠。',
    sections: [
        [
            {
                id: 'A',
                title: 'A　我對自己的想法的看法',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '寫作時，我覺得可以有自己的想法。' },
                    { question: '閱讀時，我覺得可以有自己的想法。' },
                    { question: '我覺得閱讀很有意思。' },
                    { question: '對於在線上讀到的訊息，我覺得自己的看法可以與同學不同。' },
                    { question: '對於在線上讀到的訊息，我覺得自己的看法可以與老師不同。' },
                    { question: '對於在線上讀到的訊息，我覺得自己的看法可以與朋友不同。' },
                ]
            },
        ],
         [
            {
                id: 'B',
                title: 'B　我希望作出的選擇',
                hint:'以下詢問你希望能作出的選擇，不是問老師是否已經給你這些選擇。',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '進行線上閱讀活動時，我希望能選擇自己要學習的內容。' },
                    { question: '上課進行線上閱讀時，我希望能選擇自己要讀的材料。' },
                    { question: '在課堂的線上閱讀後寫作活動中，我希望能選擇自己要寫的內容。' },
                    { question: '線上閱讀時，我希望能自己決定要讀哪些網頁或資料。' },
                    { question: '線上閱讀後寫下自己的回應時，我希望能決定自己要寫的主題。' },
                    { question: '上課進行線上閱讀時，我希望能自己決定要做哪些活動。' },
                ]
            },
        ],
               [
            {
                id: 'C',
                title: 'C　我如何回應線上閱讀活動的安排',
                hint:'請回想本學期老師安排的線上閱讀及讀後活動，並同時考慮題目所說的行動和原因。老師本來容許的選擇，不屬於這裡所說的「做與老師要求不同的事情」。若沒有題中經驗，選「非常不同意」。',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '進行線上閱讀活動時，我有時會做與老師要求不同的事情，因為我對老師安排的閱讀活動不感興趣。' },
                    { question: '進行線上閱讀活動時，我有時會做與老師要求不同的事情，因為我覺得老師安排的閱讀活動很沉悶。' },
                    { question: '進行線上閱讀活動時，我有時會做與老師要求不同的事情，因為老師安排的閱讀活動對我不重要。' },
                    { question: '進行線上閱讀活動時，我有時會做與老師要求不同的事情，因為我已不想再提升自己在老師安排的閱讀活動中的表現。' },
                    { question: '進行線上閱讀活動時，我有時會做與老師要求不同的事情，因為我更想做其他線上閱讀活動。' },
                    { question: '進行線上閱讀活動時，我有時會做與老師要求不同的事情，因為老師安排的閱讀活動令我太疲累。' },
                ]
            },
        ],
         [
            {
                id: 'D',
                title: 'D　完成相關工作的信心',
                hint:'請想一想：進行線上閱讀及運用閱讀資料完成作業時，你有多大信心能夠完成以下事情？。',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '在網上搜尋並找到與閱讀主題有關的資料。' },
                    { question: '判斷網上閱讀資料的品質，例如資料是否可靠。' },
                    { question: '透過網絡，與同學分享對閱讀活動有用的資料。' },
                    { question: '利用線上工具，與同學合作完成閱讀相關的小組作業。' },
                    { question: '根據在線上讀到的資料，撰寫或修改作業中的文字。' },
                    { question: '把線上閱讀所得的內容製作成包含圖片、聲音或影片的簡報。' },
                ]
            },
        ],
        [
            {
                id: 'E',
                title: 'E　我如何向中文老師表達需要與意見',
                hint:'請想一想：進行線上閱讀及運用閱讀資料完成作業時，你有多大信心能夠完成以下事情？。',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '線上閱讀時，我會為自己設定學習目標，引導接下來的閱讀活動。' },
                    { question: '仔細閱讀新的網頁或線上資料前，我通常會先快速瀏覽，了解內容的大致結構。' },
                    { question: '線上閱讀時，我會自己提出問題，幫助自己專注於閱讀。' },
                    { question: '線上閱讀時，我會仔細思考主題，想清楚自己應該從中學到什麼，而不只是把內容瀏覽一遍。' },
                    { question: '線上閱讀時，我會問自己一些問題，檢查是否理解讀到的內容。' },
                    { question: '線上閱讀遇到難以理解的內容時，我會改變自己的閱讀方式。' },
                    { question: '我會調整自己的學習方式，以配合線上閱讀活動的要求。' },
                ]
            },
             {
                id: 'F',
                title: 'F　我如何讓線上閱讀內容對自己更有意義',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '我會提醒自己，學習在線上讀到的內容很重要，因為以後的生活會用到。' },
                    { question: '我會努力把在線上讀到的內容與自己的興趣聯繫起來。' },
                    { question: '我會努力把在線上讀到的內容與自己在生活中想做的事情聯繫起來，讓這些內容顯得更有用。' },
                ]
            },
        ],

    ]
}